// extracted by mini-css-extract-plugin
export default {"swiperslide":"MovieTv_swiperslide__LlRSU","style_movies":"MovieTv_style_movies__OBy4P","style_movies_header":"MovieTv_style_movies_header__gOrhc"};